<!--
 * @Author: 月魂
 * @Date: 2021-02-01 14:32:22
 * @LastEditTime: 2022-01-26 15:20:53
 * @LastEditors: 月魂
 * @Description: 
 * @FilePath: \bingmayong-ukraine-mobile\src\views\Creation.vue
-->
<template>
  <div class="box">
    <Header title="creation" />
    <!-- 弹出视频 -->
    <van-overlay v-if="show" :show="show" @click="show = false">
      <div class="wrapper">
        <video
          src="http://image.wearetogether.com.cn/creation-fir.mp4"
          poster="http://cdn.topartsintermational.com/creation-video-bg-ser.jpg"
          controls
          width="100%"
          style="display: block"
          @click.stop="() => {}"
        ></video>
      </div>
    </van-overlay>
    <img
      src="http://image.wearetogether.com.cn/creation-ukraine-n.jpg"
      width="100%"
    />
    <div class="part part1">
      <div class="title">{{ setting.part1.title }}</div>
      <div class="cont">
        <div class="left">
          <p>{{ setting.part1.cont1 }}</p>
        </div>
        <div class="right">
          <p>{{ setting.part1.cont2 }}</p>
        </div>
      </div>
      <div class="picList">
        <div class="picItem">
          <img
            src="http://cdn.topartsintermational.com/creation-1.jpg"
            width="100%"
            height="100%"
          />
        </div>
        <div class="picItem">
          <img
            src="http://cdn.topartsintermational.com/creation-2.jpg"
            width="100%"
            height="100%"
          />
        </div>
        <div class="picItem">
          <img
            src="http://cdn.topartsintermational.com/creation-3.jpg"
            width="100%"
            height="100%"
          />
        </div>
        <div class="picItem">
          <img
            src="http://cdn.topartsintermational.com/creation-4.jpg"
            width="100%"
            height="100%"
          />
        </div>
        <div class="picItem">
          <img
            src="http://cdn.topartsintermational.com/creation-5.jpg"
            width="100%"
            height="100%"
          />
        </div>
        <div class="picItem">
          <img
            src="http://cdn.topartsintermational.com/creation-6.jpg"
            width="100%"
            height="100%"
          />
        </div>
        <div class="picItem">
          <img
            src="http://cdn.topartsintermational.com/creation-7.jpg"
            width="100%"
            height="100%"
          />
        </div>
        <div class="picItem">
          <img
            src="http://cdn.topartsintermational.com/creation-8.jpg"
            width="100%"
            height="100%"
          />
        </div>
      </div>
    </div>
    <div class="part part2">
      <div class="title">{{ setting.part2.title }}</div>
      <div class="cont">
        <div class="left">
          <p>{{ setting.part2.cont1 }}</p>
        </div>
        <div class="right">
          <p>{{ setting.part2.cont2 }}</p>
        </div>
      </div>
      <div class="picText">
        <div class="picLeft">
          <img
            src="http://cdn.topartsintermational.com/creation-img1.png"
            width="300px"
          />
        </div>
        <div class="textRight">
          <div class="title">
            {{ setting.part2.title1 }}
          </div>
          <p>{{ setting.part2.cont3 }}</p>
        </div>
      </div>
      <div class="picWall">
        <div class="picItem">
          <img
            src="http://cdn.topartsintermational.com/creation-img2.jpg"
            width="100%"
          />
        </div>
        <div class="picItem">
          <img
            src="http://cdn.topartsintermational.com/creation-img3.jpg"
            width="100%"
          />
        </div>
        <div class="picItem">
          <img
            src="http://cdn.topartsintermational.com/creation-img4.jpg"
            width="100%"
          />
        </div>
        <div class="picItem">
          <img
            src="http://cdn.topartsintermational.com/creation-img5.jpg"
            width="100%"
          />
        </div>
        <div class="picItem">
          <img
            src="http://cdn.topartsintermational.com/creation-img6.jpg"
            width="100%"
          />
        </div>
        <div class="picItem">
          <img
            src="http://cdn.topartsintermational.com/creation-img7.jpg"
            width="100%"
          />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
export default {
  name: 'Creation',
  components: {
    Header,
    Footer,
  },
  data () {
    return {
      show: true,
      setting: {
        part1: {
          title: this.$t('message.creation.part1.title'),
          cont1: this.$t('message.creation.part1.cont1'),
          cont2: this.$t('message.creation.part1.cont2'),
        },
        part2: {
          title: this.$t('message.creation.part2.title'),
          cont1: this.$t('message.creation.part2.cont1'),
          cont2: this.$t('message.creation.part2.cont2'),
          title1: this.$t('message.creation.part2.title1'),
          cont3: this.$t('message.creation.part2.cont3'),
        }
      },
    }
  },
}
</script>

<style scoped lang="less">
.box {
  width: 100%;
  min-height: 100vh;
  background: url("http://cdn.topartsintermational.com/creation-bg.jpg")
    no-repeat;
  background-size: cover;
  .part {
    margin: 0 auto;
    line-height: 1.8;
    .title {
      color: darkslategray;
      padding: 16px 0 0;
      text-align: center;
    }
    .cont {
      margin-top: 16px;
      p {
        text-indent: 2rem;
        padding: 10px 10px;
        color: #fff;
      }
      .left {
        background-color: #00294e;
      }
      .right {
        background-color: #000;
      }
    }
    .picList {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      margin-top: 8px;
      .picItem {
        width: 48%;
        &:nth-child(n + 3) {
          margin-top: 8px;
        }
      }
    }
  }
  .part2 {
    padding-bottom: 16px;
    .left {
      background-color: #000;
    }
    .right {
      background-color: #660000;
    }
    .picText {
      background-color: #00294e;
      margin-top: 16px;
      color: #fff;
      .picLeft {
        img {
          display: block;
          margin: auto;
        }
      }
      .title {
        color: #fff;
      }
      p {
        padding: 10px;
        text-indent: 2rem;
      }
    }
    .picWall {
      display: flex;
      margin-top: 16px;
      overflow-x: auto;
      .picItem {
        flex: none;
        width: 48%;
        margin-right: 8px;
      }
    }
  }
}
</style>